import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'realTime'
})
export class RealTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // console.log(value)
    return moment.unix(value).local().toDate();
  }

}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/shared/pipes/real-time.pipe.ts